import apiClient from '@u/apiClient'

import CheckActions from './check/actions'
import InvoiceItemAction from './invoiceItem/actions'
import PaymentActions from './payment/actions'
import ThirdPartyCostPaymentActions from './thirdPartyCostPayment/actions'
import PersonActions from './person/actions'
import SupplierOrderAction from './supplierOrder/action'
import ExportAction from './export/actions'
import InvoiceSendRecordAction from './invoiceSendRecord/actions'
import BankAction from './bank/actions'
import { resolve } from 'chart.js/helpers'
import { reject } from 'lodash-es'
import GetInvoiceListController from '@/wayfinder/actions/App/Http/Controllers/Invoice/GetInvoiceListController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'
import GetInvoiceActivitiesByIdController from '@/wayfinder/actions/App/Http/Controllers/Invoice/GetInvoiceActivitiesByIdController'
import FetchItemWikiItemsController from '@/wayfinder/actions/App/Http/Controllers/Invoice/FetchItemWikiItemsController'
import CreateInvoiceController from '@/wayfinder/actions/App/Http/Controllers/Invoice/CreateInvoiceController'
import AddWikiItemsToInvoiceController from '@/wayfinder/actions/App/Http/Controllers/Invoice/AddWikiItemsToInvoiceController'
import UpdateInvoiceController from '@/wayfinder/actions/App/Http/Controllers/Invoice/UpdateInvoiceController'
import GetDepositAmountController from '@/wayfinder/actions/App/Http/Controllers/GetDepositAmountController'
import UpdateInvoiceStatusTagController from '@/wayfinder/actions/App/Http/Controllers/Invoice/UpdateInvoiceStatusTagController'
import UpdateInvoiceFiscalCategoryController from '@/wayfinder/actions/App/Http/Controllers/Invoice/UpdateInvoiceFiscalCategoryController'
import RefreshQuotePricesController from '@/wayfinder/actions/App/Http/Controllers/Invoice/RefreshQuotePricesController'
import UpdateInvoiceRoleController from '@/wayfinder/actions/App/Http/Controllers/Invoice/UpdateInvoiceRoleController'
import CloneInvoiceController from '@/wayfinder/actions/App/Http/Controllers/Invoice/CloneInvoiceController'
import SendInvoiceController from '@/wayfinder/actions/App/Http/Controllers/Invoice/SendInvoiceController'
import GetInvoiceableController from '@/wayfinder/actions/App/Http/Controllers/Invoice/GetInvoiceableController'
import SearchInvoiceableController from '@/wayfinder/actions/App/Http/Controllers/Invoice/SearchInvoiceableController'
import EstablishMetadataInvoiceController from '@/wayfinder/actions/App/Http/Controllers/Invoice/EstablishMetadataInvoiceController'
import GetHeadersForInvoiceController from '@/wayfinder/actions/App/Http/Controllers/Invoice/GetHeadersForInvoiceController'
import ManageItemStockInvoiceController from '@/wayfinder/actions/App/Http/Controllers/Invoice/ManageItemStockInvoiceController'
import GetMergeIntoListController from '@/wayfinder/actions/App/Http/Controllers/Invoice/GetMergeIntoListController'
import ApplyMergeInvoicingController from '@/wayfinder/actions/App/Http/Controllers/Invoice/ApplyMergeInvoicingController'
import DeleteInvoiceController from '@/wayfinder/actions/App/Http/Controllers/Invoice/DeleteInvoiceController'
import SendToAccountingController from '@/wayfinder/actions/App/Http/Controllers/Invoice/SendToAccountingController'
import GetInvoiceChiftSendAttemptsController from '@/wayfinder/actions/App/Http/Controllers/Invoice/GetInvoiceChiftSendAttemptsController'
import SendToChiftInvoicingController from '@/wayfinder/actions/App/Http/Controllers/Invoice/SendToChiftInvoicingController'
import EnableInvoicePaymentSyncController from '@/wayfinder/actions/App/Http/Controllers/Invoice/EnableInvoicePaymentSyncController'
import EstablishInvoiceController from '@/wayfinder/actions/App/Http/Controllers/Invoice/EstablishInvoiceController'

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  ...CheckActions,
  ...InvoiceItemAction,
  ...PaymentActions,
  ...PersonActions,
  ...SupplierOrderAction,
  ...ExportAction,
  ...BankAction,
  ...ThirdPartyCostPaymentActions,
  ...InvoiceSendRecordAction,

  // region fetch
  async fetchInvoiceIndex({ commit }, doc_type) {
    await apiClient
      .route(
        GetInvoiceListController['/api/invoicing'].get({ query: { doc_type } })
      )
      .then(async (response) => {
        await commit('setInvoiceIndex', response.data.invoices)
        await commit('setInvoiceMetadata', response.data.metadata)
      })
      .catch((reason) => {
        if (reason.response.status === 422) {
          commit('setErrors', reason.response.data.errors)
        }
      })
  },

  async fetchAllInvoices({ commit }) {
    await apiClient
      .route(GetInvoiceListController['/api/invoicing'].get())
      .then(async (response) => {
        await commit('setInvoiceIndex', response.data.invoices)
        await commit('setInvoiceMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        await console.error('fetchAllInvoices', reason)
      })
  },

  async fetchUnpaidInvoiceIndex({ commit }) {
    await apiClient
      .get('/api/unpaid/invoicing')
      .then(async (response) => {
        await commit('setInvoiceIndex', response.data.invoices)
        await commit('setInvoiceMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        await commit('setErrors', reason.response.data.errors)
      })
  },

  async fetchPaidInvoiceIndex({ commit }) {
    await apiClient
      .get('/api/paid/invoicing')
      .then(async (response) => {
        await commit('setInvoiceIndex', response.data.invoices)
        await commit('setInvoiceMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        await commit('setErrors', reason.response.data.errors)
      })
  },
  fetchInvoiceID: ({ commit }, payload) => {
    commit('auth/setErrors', {}, { root: true })
    return new Promise((resolve, reject) => {
      return apiClient
        .get(
          `/api/invoicing/${payload.id}${
            payload.isSupplierOrder ? '?withSupplierOrderProperties=' + 1 : ''
          }`
        )
        .then((response) => {
          if (payload.supplier_order_index) {
            commit('setInvoiceAtIndex', {
              index: payload.supplier_order_index,
              invoice: response.data.invoice
            })
          } else {
            commit('setInvoice', response.data.invoice)
            commit('setInvoiceMetadata', response.data.metadata)
            // Every refetch (Pusher included) brings them up to date
            commit(
              'aiAssistant/setSuggestedActions',
              {
                resource: { type: 'invoice', id: response.data.invoice?.id },
                actions: response.data.metadata?.suggested_actions
              },
              { root: true }
            )
          }
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchNewInvoice: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetNewModelController.get(), {
          params: { ...payload.params, model: 'invoice' }
        })
        .then(async (response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchInvoiceActivitiesByInvoiceID({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetInvoiceActivitiesByIdController.get({
            invoice: payload.invoice_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchItemLinkedToWiki({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(FetchItemWikiItemsController.get())
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  // endregion

  // region store
  async storeNewInvoice({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(CreateInvoiceController.post(), payload.invoice)
        .then(async (response) => {
          resolve(response.data)
          if (response.status === 201) {
            await payload.successCallback(response?.data?.invoice?.id)
          }
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  async addWikiItemsToInvoice({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          AddWikiItemsToInvoiceController.post({ invoice: payload.id }),
          payload.items
        )
        .then(async (response) => {
          if (response.status === 200) {
            await commit('setInvoice', response.data.invoice)
          }
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region update
  updateInvoice: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(UpdateInvoiceController.put({ invoice: payload.id }), {
          invoice: payload.invoice,
          company: payload.company,
          funeralHome: payload.funeralHome,
          linkDossier: payload.linkDossier
        })

        .then((response) => {
          commit('setInvoice', response.data.invoice)
          commit('setInvoiceMetadata', response.data.metadata)
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getStandardDepositAmount({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetDepositAmountController.get({ invoice: payload.id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region delete
  // todo: supprimer cette action.
  async deleteInvoiceById({ commit }, payload) {
    await apiClient
      .delete(
        `/api/invoicing/${payload.invoice_id}?doc_type=${
          payload.doc_type ?? null
        }&invoiceable=${payload.invoiceable_type ?? null}${
          payload.dossier_id ? '&dossier_id=' + payload.dossier_id : ''
        }`
      )
      .then(async (response) => {
        processSuccessCallback(payload)
        commit('setInvoiceIndex', response.data.invoices)
      })
      .catch(async (reason) => {
        console.error('deleteInvoiceById reason', reason)
      })
  },
  // todo: supprimer cette action.
  async undoDeleteInvoiceById({ commit }, payload) {
    await apiClient
      .get(
        `/api/invoicing/undo-delete/${payload.invoice_id}?doc_type=${
          payload.doc_type ?? null
        }&invoiceable=${payload.invoiceable_type ?? null}${
          payload.dossier_id ? '&dossier_id=' + payload.dossier_id : ''
        }`
      )
      .then(async (response) => {
        processSuccessCallback(payload)
        commit('setInvoiceIndex', response.data.invoices)
      })
      .catch(async (reason) => {
        console.error('deleteInvoiceById reason', reason)
      })
  },
  // endregion

  // region change status
  async changeInvoiceStatus({ commit }, payload) {
    await apiClient
      .put(
        `/api/invoicing/${payload.invoice_id}/status${
          payload.supplier_id ? '?supplier_id=' + payload.supplier_id : ''
        }`,
        payload.form_data
      )
      .then(async (response) => {
        if ((await response.status) === 200) {
          commit('auth/setErrors', {}, { root: true })
          if (payload.supplier_id) {
            commit('setInvoiceIndex', response.data.invoices)
          } else {
            commit('setInvoice', response.data.invoice)
            commit('setInvoiceMetadata', response.data.metadata)
            // Every refetch (Pusher included) brings them up to date
            commit(
              'aiAssistant/setSuggestedActions',
              {
                resource: { type: 'invoice', id: response.data.invoice?.id },
                actions: response.data.metadata?.suggested_actions
              },
              { root: true }
            )
          }
          processSuccessCallback(payload)
        }
      })
      .catch((reason) => {
        console.error('fetchNewPayment reason', reason)
      })
  },
  async changeInvoiceStatusTag({ commit }, payload) {
    await apiClient
      .route(
        UpdateInvoiceStatusTagController.put({ invoice: payload.invoice_id }),
        payload.form_data
      )
      .then(async (response) => {
        if ((await response.status) === 200) {
          commit('auth/setErrors', {}, { root: true })
          commit('setInvoice', response.data.invoice)
          commit('setInvoiceMetadata', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch((reason) => {
        console.error('fetchNewPayment reason', reason)
      })
  },
  async changeInvoiceFiscalCategory({ commit }, payload) {
    commit('auth/setErrors', {}, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateInvoiceFiscalCategoryController.put({
            invoice: payload.invoice_id
          }),
          payload.form_data
        )
        .then(async (response) => {
          commit('setInvoice', response.data.invoice)
          commit('setInvoiceMetadata', response.data.metadata)
          resolve(response.data)
        })
        .catch((reason) => {
          console.error('fetchNewPayment reason', reason)
        })
    })
  },
  // endregion

  // region refresh quote prices
  async refreshQuotePrices({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          RefreshQuotePricesController.put({ invoice: payload.invoice_id })
        )
        .then((response) => {
          commit('setInvoice', response.data.invoice)
          commit('setInvoiceMetadata', response.data.metadata)
          resolve(response.data)
        })
        .catch((reason) => {
          console.error('refreshQuotePrices reason', reason)
          reject(reason)
        })
    })
  },
  // endregion

  // region change rôle invoice
  async changeInvoiceRole({ commit }, payload) {
    await apiClient
      .route(
        UpdateInvoiceRoleController.put({ invoice: payload.invoice_id }),
        payload.form_data
      )
      .then(async (response) => {
        if ((await response.status) === 200) {
          commit('auth/setErrors', {}, { root: true })
          processSuccessCallback(payload)
        }
      })
      .catch((reason) => {
        console.error('fetchNewPayment reason', reason)
      })
  },
  // endregion

  // region clone invoice
  cloneInvoice: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(CloneInvoiceController.put({ invoice: payload.invoice_id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion
  // region clone invoice
  cloneInvoiceChangeCompanyOrAndFuneralHome: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      const data: Record<string, unknown> = {
        company: payload.company,
        funeralHome: payload.funeralHome,
        linkDossier: payload.linkDossier,
        newType: payload.newType
      }

      if ('create_full_refund' in payload) {
        data.create_full_refund = payload.create_full_refund
      }

      if ('items_for_partiel_credit_note' in payload) {
        data.items_for_partiel_credit_note =
          payload.items_for_partiel_credit_note
      }

      if ('auth_is_responsable' in payload) {
        data.auth_is_responsable = payload.auth_is_responsable
      }

      if ('keepInvoiceable' in payload) {
        data.keep_invoiceable = payload.keepInvoiceable
      }

      if ('isConverting' in payload) {
        data.is_converting = payload.isConverting
      }

      apiClient
        .route(
          CloneInvoiceController.put({ invoice: payload.invoice_id }),
          data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion
  // region convert invoice
  convertInvoice: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(CloneInvoiceController.put({ invoice: payload.invoice_id }), {
          new_type: payload.doc_type
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region send invoice
  async sendInvoice({ commit }, payload) {
    apiClient
      .route(SendInvoiceController.post(), payload.info)
      .then(async (response) => {
        if (response.status === 200) {
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error(reason)
      })
  },
  // endregion

  async fetchSendInvoiceMessageTextConverted({ commit }, payload) {
    await apiClient
      .post('/api/convertMessageText', payload)
      .then((response) => {
        if (response.status === 200) {
          commit('setSendInvoiceMessageText', response.data.text)
          processSuccessCallback(payload)
        }
      })
      .catch((reason) => {
        console.error('fetchMessageTextConverted', reason)
      })
  },

  fetchInvoiceableList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetInvoiceableController.get({ invoice: payload.invoiceId }), {
          params: {
            filter: payload.filter
          }
        })
        .then((response) => {
          resolve(response.data.invoiceables)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  searchForAnInvoiceable: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(SearchInvoiceableController.get(), {
          params: payload.searchParams
        })
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  fetchInvoiceEstablishMetadata: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          EstablishMetadataInvoiceController.get({
            invoice: payload.invoice_id
          }),
          {
            params: { doc_role: payload.doc_role }
          }
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  setInvoiceEstablish: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .formRoute(
          EstablishInvoiceController.put({ invoice: payload.invoice_id }),
          {
            ...payload
          }
        )
        .then(async (response) => {
          commit('setInvoice', response.data.invoice)
          commit('setInvoiceMetadata', response.data.metadata)
          commit('dossier/setDossier', response.data.dossier, { root: true })
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  fetchHeaderForInvoice: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetHeadersForInvoiceController.get({ invoice: payload.invoice_id })
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  manageStockInvoice: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          ManageItemStockInvoiceController.post({ invoice: payload.id }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
          // commit('setInvoice', response.data.invoice)
          // commit('setInvoiceMetadata', response.data.metadata)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchInvoiceForMerging: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetMergeIntoListController.get({ invoice: payload.invoice_id }),
          {
            params: {
              doc_type: payload.doc_type
            }
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  applyInvoiceMerging: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          ApplyMergeInvoicingController.post({ invoice: payload.invoice_id }),
          {
            into_invoice_id: payload.into_invoice_id
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  deleteInvoicing: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteInvoiceController.delete.delete({ invoice: payload.invoice_id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  undoDeleteInvoicing: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(DeleteInvoiceController.undo.get({ id: payload.invoice_id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  sendToAccounting: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(SendToAccountingController.get({ invoice: payload.invoice_id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  /**
   * Every trip one invoice made to the accounting software, newest first.
   * Paginated server-side: the endpoint caps per_page at 100.
   */
  fetchInvoiceChiftSendAttempts: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetInvoiceChiftSendAttemptsController.get({
            invoice: payload.invoice_id
          }),
          {
            params: {
              page: payload.page,
              per_page: payload.per_page
            }
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  sendToChiftInvoicing: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          SendToChiftInvoicingController.post({ invoice: payload.invoice_id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  enableInvoicePaymentsSync: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          EnableInvoicePaymentSyncController.post({
            invoice: payload.invoice_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
